import axios from "axios";

// `doNotRetry` tells AuthProvider's catch-401 interceptor to rethrow instead of
// attempting a session refresh. `@mobsuccess-devops/axios-instance` declares the
// same optional field for its own retry interceptors, but react-shared does not
// depend on that package — declare it here so the callers that already set it
// (catch-401's own retry, the Amplify token provider) are typed.
declare module "axios" {
  // Module augmentation only works through `interface` — a `type` alias cannot
  // merge into an existing declaration.
  // oxlint-disable-next-line typescript/consistent-type-definitions
  interface AxiosRequestConfig {
    doNotRetry?: boolean;
    // Marks a request that catch-401 already replayed after a token refresh.
    // A 401 on such a request means the credential is not the problem, so
    // catch-401 repairs the session instead of refreshing again. The
    // axios-instance transient network retry still applies.
    doNotAuthRetry?: boolean;
    // Pre-merge snapshot of the caller's config. Only present when the request
    // went through a wrapper that stamps it (`@mobsuccess-devops/axios-instance`);
    // requests sent on a bare `axios.create()` instance such as
    // `PlatformMSAxiosInstance` never carry it. When present, catch-401 replays
    // from it so the retry does not inherit interceptor-mutated state.
    originalConfig?: AxiosRequestConfig;
  }
}

export const PlatformMSAxiosInstance = axios.create();
